<div class="side-container">
    <div class="side-container-content-wrapper">
        <div *ngIf="containerData?.contentType !== ContentType.NON_INPUT">
            <form class="tryb-new-design-scroll-bar">
                <div
                    *ngFor="let item of containerData?.contentItems; index as i"
                    [ngClass]="[
                        containerData?.contentType + '-container',
                        nonNil(item.leftOffsetLevel)
                            ? 'left-offset-level-' + item.leftOffsetLevel
                            : ''
                    ]"
                >
                    <div class="labels-wrapper">
                        <input
                            class="custom-input"
                            [type]="containerData?.contentType"
                            [id]="item.value + i"
                            [name]="
                                containerData?.contentType === ContentType.RADIO
                                    ? 'radio-group'
                                    : item.value
                            "
                            [value]="item.value"
                            [checked]="item.checked"
                            (change)="onChange($event.target.value)"
                        />
                        <label
                            *ngIf="
                                containerData?.contentType ===
                                ContentType.CHECKBOX
                            "
                            class="custom-input-label"
                            [ngClass]="
                                item.inputLabelStyles?.join(' ') +
                                ' custom-' +
                                containerData.contentType
                            "
                            [for]="item.value + i"
                        ></label>

                        <div class="tag-wrapper" *ngIf="item.tagForm">
                            <div
                                [ngStyle]="{
                                    backgroundColor: getTagColor(item),
                                    borderColor: getTagColor(item)
                                }"
                                [ngClass]="['tag', item.tagForm.join(' ')]"
                            >
                                <div
                                    class="line"
                                    [ngStyle]="{
                                        borderColor: getTagColor(item)
                                    }"
                                ></div>
                            </div>
                        </div>
                        <label class="text-label" [for]="item.value + i">
                            {{
                                item.translationKey
                                    ? (item.translationKey | translate)
                                    : item.value
                            }}
                        </label>
                    </div>
                    <div
                        class="info-container"
                        title="{{ item.infoText | translate }}"
                        *ngIf="item.infoText"
                    >
                        <div class="icon-wrapper">
                            <img
                                src="assets/svg/evaluation/info.svg"
                                alt="info"
                            />
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div *ngIf="containerData?.contentType === ContentType.NON_INPUT">
            <div
                *ngFor="let item of containerData.contentItems"
                [ngClass]="[containerData?.contentType + '-container']"
            >
                <div class="text-container">
                    <div class="tag-wrapper">
                        <div
                            *ngIf="item.tagForm"
                            [ngClass]="['tag', item.tagForm.join(' ')]"
                            [ngStyle]="{ backgroundColor: getTagColor(item) }"
                        ></div>
                    </div>
                    <div class="d-flex align-items-start label-container">
                        <p>
                            {{
                                item.translationKey
                                    ? (item.translationKey | translate)
                                    : item.value
                            }}
                        </p>
                    </div>
                </div>
                <div
                    class="info-container"
                    title="{{ item.infoText | translate }}"
                    *ngIf="item.infoText"
                >
                    <div class="icon-wrapper">
                        <img src="assets/svg/evaluation/info.svg" alt="info" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
